import { marked } from "marked";
import React, { useEffect } from "react";

import PropTypes from "prop-types";

// PropTypes validation
MarkedRender.propTypes = {
  message: PropTypes.string.isRequired,
  openPopup: PropTypes.any.isRequired,
};

export default function MarkedRender({ message, openPopup }) {
  const renderer = new marked.Renderer();
  renderer.link = (href, title, text) => {
    const match = href.match(/^(\d+):(.+)$/);
    if (match) {
      const id = match[1];
      const filename = match[2];
      return `<a href="#" data-id="${id}" data-filename="${filename}">${text}</a>`;
    } else {
      return `<a href="${href}"${title ? ` title="${title}"` : ""}>${text}</a>`;
    }
  };

  const getMarkdown = (input) => {
    if (input) {
      let markdown = marked(input, { sanitize: false, renderer });
      return { __html: markdown };
    }
  };

  useEffect(() => {
    const links = document.querySelectorAll("a[data-id]");
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const id = e.target.getAttribute("data-id");
        const filename = e.target.getAttribute("data-filename");
        openPopup(id, filename);
      });
    });
  }, [message, openPopup]);

  return (
    <div>
      <div dangerouslySetInnerHTML={getMarkdown(message)} />
    </div>
  );
}
